var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { normalizeObject, dataLayerPush, getEhashCookie, getSupporterID, getBlueConicProfileId } from "./utils";
export function slideInteraction(e) {
    var details = e.detail || {};
    var ehash = getEhashCookie();
    var supporter_id = getSupporterID();
    var blueConicProfileId = getBlueConicProfileId();
    var slideData = normalizeObject(__assign({ event: "slide_interaction", ehash: ehash, supporter_id: supporter_id, blueconic_profile_id: blueConicProfileId }, details));
    dataLayerPush(slideData);
}
